import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { motion } from "framer-motion";

export default function ThemeToggle() {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem("tapin-theme") || "dark";
    } catch (e) {
      return "dark";
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem("tapin-theme", theme);
    } catch (e) {
      /* private mode */
    }
  }, [theme]);

  return (
    <button
      type="button"
      data-testid="theme-toggle"
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      onClick={() => setTheme((t) => (t === "dark" ? "light" : "dark"))}
      className="theme-toggle"
    >
      <motion.span
        key={theme}
        initial={{ rotate: -90, opacity: 0, scale: 0.6 }}
        animate={{ rotate: 0, opacity: 1, scale: 1 }}
        transition={{ type: "spring", stiffness: 260, damping: 18 }}
        className="grid place-items-center"
      >
        {theme === "dark" ? <Sun size={17} /> : <Moon size={17} />}
      </motion.span>
    </button>
  );
}
